module.exports = __webpack_public_path__ + "assets/img/logo.9b6ab512.png";